<div>
    <h1> Are You Sure Delete this Order </h1>
    <hr>
    <button class="btn buttonOne" (click)="sendData('true')" >Confirm</button>
    <button class="btn buttonTow" (click)="sendData('false')">close</button>
</div>
